import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { BRAND } from "../../lib/constants";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("ph-admin") === "ok") navigate("/admin/dashboard", { replace: true });
  }, [navigate]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (password === BRAND.adminPassword) {
      localStorage.setItem("ph-admin", "ok");
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } else {
      toast.error("Incorrect password");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5" style={{ background: "radial-gradient(ellipse at top, rgba(106,13,173,0.08), #FAF8F4 60%)" }} data-testid="admin-login-page">
      <div className="w-full max-w-md ph-card p-10">
        <div className="flex items-center gap-3 mb-8">
          <img src="/logo.png" alt="Pancha Healing" className="w-11 h-11 rounded-full object-cover ring-1 ring-[#D4A855]/40" />
          <div>
            <div className="font-serif text-xl text-[#2C0A5E] leading-none">{BRAND.name}</div>
            <div className="ph-overline mt-1">Back Office</div>
          </div>
        </div>
        <h1 className="font-serif text-3xl text-[#2C0A5E]">Enter the atelier.</h1>
        <p className="text-sm text-[#6B5E7E] mt-2">Password protected access for the brand owner.</p>
        <form onSubmit={onSubmit} className="mt-7 space-y-4">
          <div className="relative">
            <input
              type={show ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="ph-input pr-16"
              autoFocus
              data-testid="admin-password-input"
            />
            <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-[#6A0DAD] hover:underline" data-testid="toggle-password">
              {show ? "Hide" : "Show"}
            </button>
          </div>
          <button type="submit" className="ph-btn-primary w-full" data-testid="admin-login-submit">Enter</button>
        </form>
      </div>
    </div>
  );
}
